import AdminAgentForm from './AdminAgentForm';

export default function AdminSubagentForm() {
    return <AdminAgentForm agentType="sub_agent" />;
}
